<template>
  <div class="cashApp1" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在识别中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul v-if="card.length > 0">
      <li v-for="(item,i) in card">
        <img class="left" src="~assets/images/card.png">
        <div class="right">
          <h2><span>{{item.title}}</span></h2>
          <div class="timer">有效期:{{item.start_time}} 至 {{item.end_time}}</div>
          <div class="price">
            <span>￥{{item.rate}}</span>
            <font>￥{{item.price}}</font>
          </div>
        </div>
        <div style="clear:both"></div>
        <div class="btn">
          <div class="user" v-if="item.user_id > 0">
            <div>领取时间：{{item.bind_time}}</div>
          </div>
          <button class="last" @click="receive(item.mypwd)" v-if="item.user_id == 0">领取</button>
          <button @click="toPush(item.card_id,item.oid,'retail')">查看</button>
        </div>
      </li>
    </ul>

    <div v-if="card.length <= 0" style="text-align:center;padding-top:40%;">暂无数据 ~</div>

    <el-dialog title="实体卡个人信息绑定" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="cardName">
        <div class="idCard">
          <span>证件类型</span> 身份证
        </div>
      </div>

      <div class="pzsc">
        <div class="left">
          <div>
            <span>姓<i>名</i>名</span>
            <font>{{name}}</font>
          </div>
          <div>
            <span>证件号</span>
            <font>{{sfz}}</font>
          </div>
        </div>
        
        <form class="right" @click="getQquey">
          <label for="file-input">
            <img src="~assets/images/ppp.png" />
          </label>
          <span>拍照识别</span>
        </form>
      </div>


      <div class="pzsc curtsss">
        <div class="left">
          <div>
            <span>手机号</span>
            <input type="text" @input="codeYzm" v-model="phone" placeholder="请输入手机号"/>
          </div>
          <div>
            <span>验证码</span>
            <input type="text" v-model="code" placeholder="请输入验证码"/>
          </div>
        </div>
        <div class="right">
          <img src="~assets/images/yzmss.png" />
          <span @click="send" :style="pat ? 'color:#000' : ''">{{sendSns}}</span>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfin">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        code:'',
        dialogFormVisible: false,
        phone:'',
        name:'',
        card:[],
        formLabelWidth:'80px',
        cardId:'',
        sendSns:'获取验证码',
        pat:false,
        flag: false,
        code:'',
        sfz:'',
      };
    },

    beforeMount() {

      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/cash');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getCard();
      }
      //this.getSign()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },


      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                            //that.getAjax(res.localData.replace('data:image/jpeg/png;base64,',''))
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/user/sfCard',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.sfz = msg.data.num,
              that.name = msg.data.name
            }else{
              alert('身份证识别失败！');
            }
            that.fullscreenLoading = false;
          }
        })
      },

      codeYzm:function(){
        let reg = /^1[0-9]{10}$/;
        var phone = this.phone;
        if (reg.test(phone)){
          this.pat = true
        }else{
          this.pat = false
        }
      },
      send:function(){
        if(!this.pat || this.flag){
          return false;
        }
        if(this.phone == ''){
          alert('请输入手机号码');
          return false;
        }
        let reg = /^1[0-9]{10}$/
        if(!reg.test(this.phone)){
          alert('请输入正确的手机号码');
          return false;
        }
        var i = 60
        let time = setInterval(() => {
          i--
          if(i < 1){
            this.sendSns = '获取验证码';
            clearInterval(time)
            this.pat = false;
            this.flag = false
            return false;
          }
          this.sendSns = i+'秒后重试';
          this.flag = true
          }, 1000)

        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/SendSms',
          params:{
            phone:that.phone
          }
        }).then(function(response){
          if(response.data.status == 200){
            
          }else{
            alert('短信下发失败');
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      toPush:function(index,id,url){
        this.$router.push({
          path:url,
          query:{
            id:index,
            oid:id
          }
        })
      },
      receive:function(id){
        this.dialogFormVisible = true
        this.cardId = id;
      },
      comfin:function(){
        var that = this;

        if(that.sfz == ''){
          that.$message('请先识别身份证！');
          return false;
        }
        if(that.name == ''){
          that.$message('请输入姓名！');
          return false;
        }
        if(that.phone == ''){
          that.$message('请输入手机号！');
          return false;
        }
        that.axios({
          method:'post',
          url:that.$host+'home/user/drawSave',
          params:{
            user_id:that.userData.id,
            name:that.name,
            phone:that.phone,
            id:that.cardId,
            code:that.code,
            sfz:that.sfz,
          }
        }).then(function(response){
          var res =  response.data
          if(res.status == 200){
            that.$message(res.message);
            that.getCard();
          }else{
            that.$message.error(res.message);
          }
          that.dialogFormVisible = false
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getCard:function(e){
        var id = this.$route.query.id != '' ? this.$route.query.id : '';
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/user/receive',
          params:{
            user_id:that.userData.id,
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.card = res
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-message{
    top:auto !important;
    bottom:20px !important;
    min-width:70% !important;
  }
  .el-message{
    transition: opacity .3s,transform .4s,bottom .4s !important;
  }
  .el-dialog{
    width:90% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .cashApp1{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
  }
  .cashApp1 ul{
    display:block;
    width:92%;
    margin:0 auto;
    padding:15px 0
  }
  .cashApp1 ul li{
    background:#fff;
    border-radius:6px;
    margin-bottom:15px
  }
  .cashApp1 ul li .left{
    float:left;
    width:70px;
    border-radius: 6px;
    margin:15px 2% 0 4%
  }
  .cashApp1 ul li .right{
    float:left;
    width:74%;
    margin-top:7px;
  }
  .cashApp1 ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .cashApp1 ul li h2{
    width:100%;
    margin:0 auto;
  }
  .cashApp1 ul li h2 span{
    width:100%;
    font-size:15px;
  }
  .cashApp1 ul li .timer,.cashApp1 ul li .price{
    width:100%;
    margin:0 auto;
    font-size:14px;
    color:#666;
    padding-top:6px
  }
  .cashApp1 ul li .price span{
    color:#f00;
    padding-right:5px;
    font-weight:bold
  }
  .cashApp1 ul li .price font{
    color:#999;
    text-decoration: line-through;
    font-size:12px;
  }
  .cashApp1 ul li .btn{ 
    width:92%;
    margin:0 auto;
    height:30px;
    padding:10px 0
  }
  .cashApp1 ul li .btn .user{
    float:left;
    font-size:12px;
    color:#666;
    height:30px;
    line-height:30px;
  }
  .cashApp1 ul li .btn button{
    float:right;
    margin-left:15px;
    height:30px;
    width:65px;
    border:solid 1px #007aff;
    border-radius:30px;
    background:none;
    color: #007aff;
    font-size:15px;
    font-weight:bold;
  }
  .cashApp1 ul li .btn button.last{
    color:#f00;
    border-color:#f00
  }

  .cardName{
    display:block;
    width:92%;
    margin:0 auto;
    margin-bottom:15px;
    position:relative
  }
  .cardName .idCard{
    display:block;
    border-bottom:solid 1px #f1f1f1;
    padding-bottom:10px;
    font-size:15px;
    color:#333;
  }
  .cardName .idCard span{
    font-size:15px;
    color:#333;
    padding-bottom:3px;
    padding-right:15px
  }
  .curtsss{
    border-top:solid 1px #f1f1f1;
  }
  .pzsc{
    display:block;
    width:92%;
    margin:0 auto;
    margin-bottom:5px;
  }
  .pzsc:after {
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .pzsc .left{
    float:left;
    width:75%;
  }
  .pzsc .left div{
    border-bottom:solid 1px #f1f1f1;
    padding:13px 0;
    font-size:15px;
  }
  .pzsc .left div:last-child{
    border-bottom:none
  }
  .pzsc .left div span{
    padding-right:15px
  }
  .pzsc .left div span i{
    opacity: 0
  }

  .pzsc .left div input{
    display:inline-block;
    font-size:15px;
    color:#333;
    outline:none;
    width:65%;
    border:none
  }

  .pzsc .right{
    float:left;
    width:25%;
    text-align:right;
    font-size:10px;
    position:relative
  }
  .pzsc .right:after{
    content:'';
    height:60px;
    width:1px;
    background:#f1f1f1;
    position:absolute;
    left:10px;
    top:20%;
  }
  .pzsc .right img{
    display:block;
    width:30px;
    height:30px;
    margin-left:50%;
    margin-bottom:5px;
    margin-top:15px
  }
  .pzsc .right > input{
    display: none;
  }
</style>